import * as React from 'react';
import { useContext } from 'react';

import type { DegreeCollectionSet } from 'bundles/browse-common/types/degreeCollection';

type DegreeCollectionContextType = {
  collectionSet: DegreeCollectionSet;
  isLoading: boolean;
};

const DegreeCollectionContext = React.createContext<DegreeCollectionContextType | undefined>(undefined);

export const useDegreeCollection = () => {
  return useContext(DegreeCollectionContext);
};

export default DegreeCollectionContext;
